import {
  ADD_WEB_LINK,
  ADD_WEB_LINK_FAILED,
  ADD_WEB_LINK_SUCCESS,
  GET_WEB_LINK,
  GET_WEB_LINK_SUCCESS,
  GET_WEB_LINK_FAILED,
  RESET_WEB_LINK,
  UPDATE_WEB_LINK,
  UPDATE_WEB_LINK_SUCCESS,
  UPDATE_WEB_LINK_FAILED,
  GET_WEB_LINK_LIST,
  GET_WEB_LINK_LIST_SUCCESS,
  GET_WEB_LINK_LIST_FAILED,
  OPEN_DELETE_WEB_LINK_MODAL,
  HIDE_DELETE_WEB_LINK_MODAL,
  DELETE_WEB_LINK,
  DELETE_WEB_LINK_SUCCESS,
  DELETE_WEB_LINK_FAILED,
  UPDATE_WEB_LINK_ORDER,
  UPDATE_WEB_LINK_ORDER_SUCCESS,
  UPDATE_WEB_LINK_ORDER_FAILED,
  UPDATE_WEB_LINK_STATUS,
  UPDATE_WEB_LINK_STATUS_SUCCESS,
  UPDATE_WEB_LINK_STATUS_FAILED,
  RESET_WEB_LINK_LIST,
  GET_WEB_LINK_CLICKS,
  GET_WEB_LINK_CLICKS_SUCCESS,
  GET_WEB_LINK_CLICKS_FAILED,
  RESET_WEB_LINK_CLICKS,
} from "./actionTypes"

export const addWebLink = params => ({
  type: ADD_WEB_LINK,
  payload: params,
})

export const addWebLinkSuccess = response => ({
  type: ADD_WEB_LINK_SUCCESS,
  payload: response,
})

export const addWebLinkFailed = error => ({
  type: ADD_WEB_LINK_FAILED,
  payload: error,
})

export const getWebLink = params => ({
  type: GET_WEB_LINK,
  payload: params,
})

export const getWebLinkSuccess = response => ({
  type: GET_WEB_LINK_SUCCESS,
  payload: response,
})

export const getWebLinkFailed = error => ({
  type: GET_WEB_LINK_FAILED,
  payload: error,
})

export const resetWebLink = () => ({
  type: RESET_WEB_LINK,
  payload: {},
})

export const updateWebLink = params => ({
  type: UPDATE_WEB_LINK,
  payload: params,
})

export const updateWebLinkSuccess = response => ({
  type: UPDATE_WEB_LINK_SUCCESS,
  payload: response,
})

export const updateWebLinkFailed = error => ({
  type: UPDATE_WEB_LINK_FAILED,
  payload: error,
})

export const getWebLinkList = params => ({
  type: GET_WEB_LINK_LIST,
  payload: params,
})

export const getWebLinkListSuccess = response => ({
  type: GET_WEB_LINK_LIST_SUCCESS,
  payload: response,
})

export const getWebLinkListFailed = error => ({
  type: GET_WEB_LINK_LIST_FAILED,
  payload: error,
})

export const resetWebLinkList = () => ({
  type: RESET_WEB_LINK_LIST,
  payload: {},
})

export const openDeleteWebLinkModal = () => ({
  type: OPEN_DELETE_WEB_LINK_MODAL,
  payload: {},
})

export const hideDeleteWebLinkModal = () => ({
  type: HIDE_DELETE_WEB_LINK_MODAL,
  payload: {},
})

export const deleteWebLink = params => ({
  type: DELETE_WEB_LINK,
  payload: params,
})

export const deleteWebLinkSuccess = response => ({
  type: DELETE_WEB_LINK_SUCCESS,
  payload: response,
})

export const deleteWebLinkFailed = error => ({
  type: DELETE_WEB_LINK_FAILED,
  payload: error,
})

export const updateWebLinkOrder = params => ({
  type: UPDATE_WEB_LINK_ORDER,
  payload: params,
})

export const updateWebLinkOrderSuccess = response => ({
  type: UPDATE_WEB_LINK_ORDER_SUCCESS,
  payload: response,
})

export const updateWebLinkOrderFailed = error => ({
  type: UPDATE_WEB_LINK_ORDER_FAILED,
  payload: error,
})

export const updateWebLinkStatus = params => ({
  type: UPDATE_WEB_LINK_STATUS,
  payload: params,
})

export const updateWebLinkStatusSuccess = response => ({
  type: UPDATE_WEB_LINK_STATUS_SUCCESS,
  payload: response,
})

export const updateWebLinkStatusFailed = error => ({
  type: UPDATE_WEB_LINK_STATUS_FAILED,
  payload: error,
})

export const getWebLinkClicks = params => ({
  type: GET_WEB_LINK_CLICKS,
  payload: params,
})

export const getWebLinkClicksSuccess = response => ({
  type: GET_WEB_LINK_CLICKS_SUCCESS,
  payload: response,
})

export const getWebLinkClicksFailed = error => ({
  type: GET_WEB_LINK_CLICKS_FAILED,
  payload: error,
})

export const resetWebLinkClicks = () => ({
  type: RESET_WEB_LINK_CLICKS,
  payload: {},
})
